import {del} from 'lib/fetch';
import {SessionRuntype} from '../model';

export async function SignOutAPI() {
    return await del({url: 'session'}, SessionRuntype);
}
